const formatDuty = (rank, position) =>
  [rank, position].filter(Boolean).join(' · ');

export const buildDepApprovalFromRows = (rows = [], userInfo = {}) => {
  const grouped = {};

  rows.forEach((row) => {
    if (!row.id) return;

    const isExternal = row.internalYn === '1';
    const depCd = isExternal ? 'EXTERNAL' : row.depCd;
    const depNm = isExternal ? '외부인' : row.depNmLast;

    if (!grouped[depCd]) {
      grouped[depCd] = { depCd, depNm, managers: [] };
    }

    grouped[depCd].managers.push({
      id: row.id,
      name: row.name,
      rank: row.rank,
      position: row.position,
      photo: row.photo,
      tel: row.tel,
      companyNm: isExternal ? row.affiliationNm : '',
    });
  });

  const myId = userInfo.decUserId;
  if (!myId) return Object.values(grouped);

  const isExternal = userInfo.internalYn === '1';
  const depCd = isExternal ? 'EXTERNAL' : userInfo.depCd;

  if (!grouped[depCd]) {
    grouped[depCd] = {
      depCd,
      depNm: isExternal ? '외부인' : userInfo.depNm,
      managers: [],
    };
  }

  const alreadyListed = grouped[depCd].managers.some(
    (manager) => String(manager.id) === String(myId)
  );

  if (!alreadyListed) {
    grouped[depCd].managers.unshift({
      id: myId,
      name: userInfo.userNm,
      rank: userInfo.rank,
      position: userInfo.posiNm,
      photo: userInfo.photo,
      tel: userInfo.tel,
      companyNm: isExternal ? userInfo.affiliationNm : '',
    });
  }

  return Object.values(grouped);
};

export const normalizeApprovalLine = (rows = [], depApproval = []) => {
  const managers = depApproval.flatMap((dep) =>
    dep.managers.map((manager) => ({
      ...manager,
      depCd: dep.depCd,
      depNm: manager.companyNm || dep.depNm,
    }))
  );

  const findManager = (id) =>
    managers.find((manager) => String(manager.id) === String(id));

  const getProfile = (row) =>
    findManager(row.id) || {
      depCd: row.depCd,
      depNm: row.depNm,
      name: row.approverNm,
      rank: row.rank,
      position: row.position,
      photo: row.photo,
    };

  const depHeads = rows
    .filter((row) => row.approverType === 'INTERMEDIATE')
    .sort((a, b) => a.no - b.no)
    .map((row) => {
      const manager = getProfile(row);

      return {
        depCd: manager?.depCd || '',
        depNm: manager?.depNm || '',
        headId: row.id,
        headNm: manager?.name || '',
        rank: manager?.rank || '',
        jobPosition: manager?.position || '',
        position: formatDuty(manager?.rank, manager?.position),
        photo: manager?.photo || '',
        no: row.no,
      };
    });

  const finalRow = rows
    .filter((row) => row.approverType === 'FINAL')
    .sort((a, b) => a.no - b.no)[0];
  const finalManager = finalRow ? getProfile(finalRow) : null;
  const safetyManager = finalRow
    ? {
        depCd: finalManager?.depCd || '',
        depNm: finalManager?.depNm || '',
        smId: finalRow.id,
        smNm: finalManager?.name || '',
        rank: finalManager?.rank || '',
        jobPosition: finalManager?.position || '',
        position: formatDuty(finalManager?.rank, finalManager?.position),
        photo: finalManager?.photo || '',
        no: finalRow.no,
      }
    : null;

  const observerRow = rows.find((row) => row.approverType === 'WITNESS');
  const observerManager = observerRow ? getProfile(observerRow) : null;
  const observer = observerRow
    ? {
        depCd: observerManager?.depCd || '',
        depNm: observerManager?.depNm || '',
        id: observerRow.id,
        name: observerManager?.name || '',
        rank: observerManager?.rank || '',
        jobPosition: observerManager?.position || '',
        position: formatDuty(observerManager?.rank, observerManager?.position),
        photo: observerManager?.photo || '',
      }
    : null;

  return {
    depHeads,
    safetyManager,
    observer,
    smId: safetyManager?.smId || '',
  };
};
